import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx-js-style';
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable({
  providedIn: 'root'
})
export class ExportexcelService {

  private readonly INDIAN_NUMBER_FORMAT = '_(* #,##,##0.00_);_(* (#,##,##0.00);_(* "-"_);_(@_)';

  public exportAsExcelFile(json: any[], excelFileName: string): void {
    if (!json || json.length === 0) return;

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json, { skipHeader: false });
    const range = XLSX.utils.decode_range(worksheet['!ref']!);
    const header = Object.keys(json[0]);
    const numberCols = header
      .map((h, i) => {
        const lower = h.toLowerCase();
        return (lower.includes('amount') || lower.includes('amt') || lower.includes('value') ||
                lower.includes('cgst') || lower.includes('sgst') || lower.includes('igst') ||
                lower.includes('total')) ? i : -1;
      })
      .filter(i => i !== -1);
    for (let c = range.s.c; c <= range.e.c; c++) {
      const addr = XLSX.utils.encode_cell({ r: 0, c });
      if (!worksheet[addr]) continue;

      const isNumberCol = numberCols.includes(c);
      worksheet[addr].s = {
         font: { bold: true, color: { rgb: "000000" } },
        fill: { patternType: 'solid', fgColor: { rgb: "FFADD8E6" } },
        alignment: { horizontal: isNumberCol ? 'right' : 'center', vertical: 'center' }
      };
    }
    for (let r = 1; r <= range.e.r; r++) {
      for (let c = 0; c <= range.e.c; c++) {
        const addr = XLSX.utils.encode_cell({ r, c });
        const cell = worksheet[addr];
        if (!cell) continue;

        const isNumberCol = numberCols.includes(c);

        if (isNumberCol && typeof cell.v === 'number') {
          cell.z = this.INDIAN_NUMBER_FORMAT;
        }
      }
    }


    worksheet['!cols'] = header.map((headerName, colIndex) => {
      const headerLength = headerName.length;

      const contentLengths = json.map(row => {
        const val = row[headerName];
        return val === null || val === undefined ? 0 : val.toString().length;
      });

      const maxContentLength = contentLengths.length > 0 ? Math.max(...contentLengths) : 0;
      const longest = Math.max(headerLength, maxContentLength);
      let width = longest + 8;
      if (headerLength > maxContentLength) {
        width += 4;
      }

      return { wch: Math.min(Math.max(width, 14), 60) };
    });

    const workbook: XLSX.WorkBook = {
      Sheets: { 'data': worksheet },
      SheetNames: ['data']
    };

    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array', compression: true });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data = new Blob([buffer], { type: EXCEL_TYPE });
    FileSaver.saveAs(data, `${fileName}_${new Date().getTime()}${EXCEL_EXTENSION}`);
  }
}
